export default "__VITE_ASSET__845e66a0__"